import { render, staticRenderFns } from "./devceiPandianDetailList.vue?vue&type=template&id=36459d18&scoped=true&"
import script from "./devceiPandianDetailList.vue?vue&type=script&lang=js&"
export * from "./devceiPandianDetailList.vue?vue&type=script&lang=js&"
import style0 from "./devceiPandianDetailList.vue?vue&type=style&index=0&id=36459d18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36459d18",
  null
  
)

export default component.exports